/** Status da cobrança (charge) que indicam pagamento confirmado. */
const CONFIRMADOS_COBRANCA = new Set([
  'paid',
  'approved',
  'settled',
  'identified',
])

/** Status que indicam falha definitiva. */
const RECUSADOS = new Set([
  'unpaid',
  'canceled',
  'cancelled',
  'refused',
  'failed',
  'contested',
  'not_authorized',
  'denied',
])

export type ClassificacaoStatusCartao = 'confirmado' | 'recusado' | 'aguardando'

export function classificarStatusCobrancaCartao(
  status: string | null | undefined
): ClassificacaoStatusCartao {
  const s = String(status || '').toLowerCase()
  if (CONFIRMADOS_COBRANCA.has(s)) return 'confirmado'
  if (RECUSADOS.has(s)) return 'recusado'
  return 'aguardando'
}

/**
 * Assinatura "active" na EFI != pagamento aprovado.
 * Só libera o plano quando a cobrança (charge) estiver paga/aprovada.
 */
export function resolverClassificacaoCartao(input: {
  chargeStatus?: string | null
  subscriptionStatus?: string | null
}): ClassificacaoStatusCartao {
  const chargeStatus = input.chargeStatus
  const subscriptionStatus = input.subscriptionStatus

  if (chargeStatus) {
    const daCobranca = classificarStatusCobrancaCartao(chargeStatus)
    if (daCobranca !== 'aguardando') return daCobranca
  }

  if (subscriptionStatus) {
    const s = String(subscriptionStatus).toLowerCase()
    if (RECUSADOS.has(s)) return 'recusado'
    // new, new_charge, active, waiting… assinatura criada, cobrança ainda pendente
    return 'aguardando'
  }

  return 'aguardando'
}

/** @deprecated Prefer resolverClassificacaoCartao com charge + subscription */
export function classificarStatusCartaoEfi(
  status: string | null | undefined
): ClassificacaoStatusCartao {
  return classificarStatusCobrancaCartao(status)
}

export function mensagemAguardandoBanco() {
  return 'Se seu banco enviou SMS ou notificação no app do cartão, confirme a compra agora. Só liberamos o plano após aprovação.'
}

export function mensagemRecusaCartao(motivo?: string | null, status?: string | null) {
  const base =
    motivo?.trim() ||
    'Transação não autorizada pelo emissor do cartão. Confira o app/SMS do banco ou tente outro cartão.'
  if (status && !base.toLowerCase().includes(String(status).toLowerCase())) {
    return `${base} (status EFI: ${status})`
  }
  return base
}
